import { SET_LAYOUT_TITLE } from "../../utils/constants";

export const setHeaderTitle = (title) => ({
  type: SET_LAYOUT_TITLE,
  payload: title,
});
